import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Select } from '@ngxs/store';
import { map, Observable } from 'rxjs';
import { LoggedInUser } from '../models/logged-in-user.model';
import { UserState } from '../state/user/user.state';

@Injectable({
  providedIn: 'root',
})
export class LoggedOutGuard {
  @Select(UserState.user)
  user$!: Observable<LoggedInUser | null>;

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.user$.pipe(
      map((user) => {
        if (!user) {
          return true;
        }

        return this.router.createUrlTree(['']);
      })
    );
  }
}
